import React, { useRef, useState, useEffect } from "react";
import styles from "./Approach.module.css";

const approach1 = process.env.PUBLIC_URL + "/svg/approach1.svg";
const approach2 = process.env.PUBLIC_URL + "/svg/approach2.svg";

export default function Approach() {
    const refs = useRef([]);
    const [visible, setVisible] = useState({}); // {0:true, 1:true ...}

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const idx = entry.target.dataset.index;
                        setVisible((prev) => ({ ...prev, [idx]: true }));
                        observer.unobserve(entry.target); // 한 번만 실행
                    }
                });
            },
            { threshold: 0.5 }
        );

        const currentRefs = refs.current;
        currentRefs.forEach((el) => el && observer.observe(el));
        return () => currentRefs.forEach((el) => el && observer.unobserve(el));
    }, []);

    const items = [
        {
            img: approach2,
            text1: "이사, 공유숙소, 맛집, 핫플레이스 방문",
            text2: "비대면 주차장 현황 확인 서비스",
            text3: "\"도심의 핫 플레이스도, 맛집 탐방도",
            text4: "언제 어디서든 주차장 확인부터!\"",
            layout: "leftLayout"
        },
        {
            img: approach1,
            text1: "빌라, 맛집, 공유 숙소 등",
            text2: "주차 공간의 여유가 필요한 도심 속 주차장 관리",
            text3: "\"누구나 쉽게, 공간 효율은 높이고,",
            text4: "운영은 스마트하게\"",
            layout: "rightLayout"
        },
    ];

    return (
        <div className={styles.container}>
            {items.map((item, i) => (
                <div
                    key={i}
                    data-index={i}
                    ref={(el) => (refs.current[i] = el)}
                    className={`${styles.block} ${styles[item.layout]}`}
                >
                    <img
                        src={item.img}
                        alt={`approach${i}`}
                        className={`${styles.image} ${visible[i] ? (item.layout === "leftLayout" ? styles.slideRight : styles.slideLeft) : ""
                            }`}
                    />
                    <div
                        className={`${styles.text} ${visible[i] ? (item.layout === "leftLayout" ? styles.textLeft : styles.textRight) : ""
                            }`}
                    >
                        <div className={styles.text8}>{item.text1}</div>
                        <div className={styles.text9}>{item.text2}</div>
                        <div className={styles.text10}>{item.text3}</div>
                        <div className={styles.text10}>{item.text4}</div>
                    </div>
                </div>
            ))}
        </div>
    );
}
